import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { AuthService } from "src/app/pages/services/auth-services.service";
import { StorageKey } from "src/app/pages/services/storage.model";
import { StorageService } from "src/app/pages/services/storage.service";

@Component({
  selector: "app-user-menu",
  templateUrl: "./user-menu.component.html",
  styleUrls: ["./user-menu.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class UserMenuComponent implements OnInit {
  public userImage = "../assets/img/users/user.png";
  token: string;
  info: string;
  user: any;
  principal: any;
  facility_code: any;
  constructor(
    private authService: AuthService,
    private storeSvc: StorageService
  ) {
    this.token = localStorage.getItem("currentClient");
    this.info = localStorage.getItem("userInfo");
    if (this.token) {
      this.user = this.storeSvc.read(StorageKey.CURRENT_USER);
      if (this.user) {
        this.principal = this.user.principal;
        //
        // this.facility_code = this.principal.facility.facilityCode;
      }
    }
  }

  ngOnInit() {}

  logout() {
    this.authService.logout("isDirectCall");
  }
}
